import { useEffect, useRef } from "react";

const features = [
  {
    num: "01",
    icon: "ri-flashlight-line",
    title: "Ölçeklenebilir Güç",
    highlight: "5 – 100 MWh",
    desc: "Projenizin ihtiyacına göre modüler olarak büyütülebilen enerji kapasitesi. Küçük ölçekten büyük endüstriyel tesislere kadar esnek çözümler.",
  },
  {
    num: "02",
    icon: "ri-time-line",
    title: "Süreklilik",
    highlight: "Uzun ömürlü yapı",
    desc: "20+ yıl tasarım ömrü, yüksek döngü dayanımı ve düşük bakım maliyeti. Kesintisiz enerji güvencesi için mühendislik odaklı tasarım.",
  },
  {
    num: "03",
    icon: "ri-settings-3-line",
    title: "%100 Özel Tasarım",
    highlight: "Projeye özel",
    desc: "Her proje için sıfırdan mühendislik çözümü. Arazi koşulları, iklim, kapasite ve entegrasyon gereksinimlerine göre özelleştirilmiş sistem.",
  },
];

export default function FeaturesSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const cards = entry.target.querySelectorAll(".feature-card");
            cards.forEach((card, i) => {
              setTimeout(() => {
                (card as HTMLElement).style.opacity = "1";
                (card as HTMLElement).style.transform = "translateY(0)";
              }, i * 150);
            });
          }
        });
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="ozellikler" ref={sectionRef} className="py-24 md:py-32 bg-[#FAFAFA]">
      <div className="max-w-[1200px] mx-auto px-6">
        {/* Header */}
        <div className="mb-16 md:mb-20">
          <span className="text-[#A66A3F] text-xs font-semibold tracking-[0.2em] uppercase">
            Temel Özellikler
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-[#2B2B2B] mt-3">
            Neden AKSESS BESS?
          </h2>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((f) => (
            <div
              key={f.num}
              className="feature-card bg-white border border-gray-100 p-8 md:p-10 group hover:-translate-y-1 transition-transform duration-300 cursor-default"
              style={{ opacity: 0, transform: "translateY(24px)", transition: "opacity 0.6s ease, transform 0.6s ease" }}
            >
              {/* Number */}
              <p className="text-7xl font-bold text-[#F0F0F0] leading-none mb-2 select-none">
                {f.num}
              </p>

              {/* Accent line */}
              <div className="w-10 h-0.5 bg-[#A66A3F] mb-6 group-hover:w-16 transition-all duration-300" />

              {/* Icon */}
              <div className="w-10 h-10 flex items-center justify-center mb-4">
                <i className={`${f.icon} text-2xl text-[#A66A3F]`} />
              </div>

              {/* Title */}
              <h3 className="text-lg font-bold text-[#2B2B2B] mb-2">{f.title}</h3>

              {/* Highlight */}
              <p className="text-2xl font-bold text-[#A66A3F] mb-4">{f.highlight}</p>

              {/* Description */}
              <p className="text-sm text-[#6A6A6A] leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>

        {/* Bottom row: specs */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-0 border border-gray-100 bg-white">
          {[
            { label: "Batarya Teknolojisi", value: "LFP / NMC" },
            { label: "Soğutma Sistemi", value: "Aktif Hava / Sıvı" },
            { label: "Güvenlik Standardı", value: "IEC 62619" },
            { label: "İletişim Protokolü", value: "Modbus / CAN" },
          ].map((spec, i) => (
            <div
              key={spec.label}
              className={`px-6 py-6 ${i < 3 ? "border-r border-gray-100" : ""}`}
            >
              <p className="text-xs text-[#A66A3F] font-semibold tracking-widest uppercase mb-2">
                {spec.label}
              </p>
              <p className="text-base font-bold text-[#2B2B2B]">{spec.value}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
